<div>
  <label
    *ngIf="label"
    [for]="id" class="mb-2 text-center"
    data-cy="quantity-label"
    [id]="labelID"
  >{{label}}</label>
  <div
    [class.quantity-focus]="hasFocus"
    class="input-group d-flex flex-nowrap"
  >
    <input
      #innerInput
      [(ngModel)]="innerValue"
      (ngModelChange)="onChange(innerValue)"
      (blur)="setHasFocus(false);onTouch()"
      (focus)="setHasFocus(true)"
      (keydown.enter)="setHasFocus(false)"
      (keydown.arrowDown)="$event.preventDefault(); decrement()"
      (keydown.arrowUp)="$event.preventDefault(); increment()"
      [class.ds-cursor--not-allowed]="disabled"
      [class.ds-color--grey-5]="disabled"
      [class.ds-error]="showErrorMessages && !!errors"
      [class.ds-focus]="hasFocus"
      [disabled]="disabled"
      [id]="id"
      [name]="id"
      [attr.aria-invalid]="showErrorMessages && !!errors"
      [attr.aria-describedby]="errorMessageID"
      [attr.aria-labelledby]="labelID + ' ' + ariaLabelledBy"
      [tabindex]="0"
      [readonly]="readonly || disableTextInput"
      class="quantity-input justify-content-center align-items-center ds-body order-2"
      data-cy="quantity-input"
      inputmode="numeric"
      pattern="[0-9]*"
      type="text"
      aria-live="polite"
    />
    <div class="input-group-prepend order-1">
      <button
        (click)="decrement()"
        [attr.aria-label]="ariaLabelIncrement || 'Decrease Quantity by ' + this.step"
        [class.ds-cursor--not-allowed]="isMinusDisabled()"
        [disabled]="isMinusDisabled()"
        [tabindex]="0"
        class="quantity-button ds-button ds-button--secondary d-flex justify-content-center align-items-center"
        data-cy="quantity-decrement-button"
        role="button"
        type="button"
      >
        <em class="ds-icon--minus ds-icon--normal"></em>
      </button>
    </div>
    <div class="input-group-append order-3">
      <button
        (click)="increment()"
        [attr.aria-label]="ariaLabelIncrement || 'Increase Quantity by ' + this.step"
        [class.ds-cursor--not-allowed]="isPlusDisabled()"
        [disabled]="isPlusDisabled()"
        [name]=""
        [tabindex]="0"
        class="quantity-button ds-button ds-button--primary d-flex justify-content-center align-items-center"
        data-cy="quantity-increment-button"
        role="button"
        type="button"
      >
        <em class="ds-icon--plus ds-icon--normal"></em>
      </button>
    </div>
  </div>
</div>
<ds-input-error
  [id]="errorMessageID"
  [error]="error"
  [showError]="showError"
></ds-input-error>
